import React, { useEffect } from "react";
import { Form, Select, Typography } from "antd";

import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

// Mirrors the server enum it.polimi.lode.model.building.BlockPosition.
const BLOCK_POSITIONS = [
    { value: "INTERNAL", label: "Internal" },
    { value: "EXTERNAL", label: "External" },
];

const AddedBlockForm = props => {
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;

    const formItemLayout = {
        labelCol: { sm: { span: 8 } },
        wrapperCol: { sm: { span: 16 } },
    };

    useEffect(() => {
        if (props.record.asset) {
            form.setFieldsValue({
                position: props.record.asset.position,
            });
        }
    }, [props.record.asset, form]);

    useEffect(() => {
        if (!isEditMode && props.record.asset) {
            form.resetFields();
            form.setFieldsValue({
                position: props.record.asset.position,
            });
        }
    }, [isEditMode, form, props.record.asset]);

    const handleFormChange = () => {
        if (!isEditMode) return;

        const values = form.getFieldsValue();
        const errors = form.getFieldsError();
        const isValid = errors.every(error => !error.errors.length);

        const newAsset = { ...props.record };
        newAsset.asset.position = elvis(values.position);
        newAsset.valid = isValid;

        props.parentCallback(newAsset);
    };

    return (
        <Form
            form={form}
            {...formItemLayout}
            className="details_form"
            onValuesChange={handleFormChange}
            onFieldsChange={handleFormChange}
        >
            <Title level={4}>Added block</Title>
            <Form.Item label="Position" name="position">
                <Select disabled={!isEditMode} allowClear>
                    {BLOCK_POSITIONS.map(opt => (
                        <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                    ))}
                </Select>
            </Form.Item>
        </Form>
    );
};

export default AddedBlockForm;
